import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchClaims(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("claims/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchSelfClaims(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("claims/self", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchClaim(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`claims/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    approve(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("claims/approve", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editClaim(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("claims", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteClaim(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("claims", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteClaimItem(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("claims/item", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteClaimDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("claims/documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
